import {
	CLEAR_FILEUPLOAD,
	CLEAR_INPUTSAVE,
	CLEAR_LOADROUTES,
	DOC_APPROVING_INITIALIZE,
	DOC_SUBMITTING_INITIALIZE,
	FILE_UNSELECTING_ALL,
	GET_DOCS_REQ_INITIALIZE,
} from "./types";

export const resetDocForm = () => (dispatch) => {
	dispatch({
		type: CLEAR_INPUTSAVE,
	});
	dispatch({
		type: CLEAR_FILEUPLOAD,
	});
	dispatch({
		type: CLEAR_LOADROUTES,
	});
	dispatch({
		type: DOC_SUBMITTING_INITIALIZE,
	});
	dispatch({
		type: FILE_UNSELECTING_ALL,
	});
	dispatch({
		type: DOC_APPROVING_INITIALIZE,
	});

	dispatch({
		type: GET_DOCS_REQ_INITIALIZE,
	});
};
